import datadogActions, { DATADOG_EVENT } from './index';

type AdsLibraryContextValue = string | number | boolean | undefined;

type AdsLibraryContext = Record<string, AdsLibraryContextValue>;

export type AdsLibraryNetwork = 'facebook' | 'google';
export type AdsLibraryRegion = 'eu' | 'us';
export type AdsLibraryCreativeViewType = 'accordion_expand' | 'dialog_open';

const serializeValue = (value: unknown): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value.length ? value.join(',') : undefined;
  }

  if (value instanceof Date) {
    return value.toISOString().slice(0, 10);
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (typeof value === 'number' || typeof value === 'string') {
    return String(value);
  }

  return undefined;
};

export const trackAdsLibraryNetworkChange = (
  network: AdsLibraryNetwork,
  previousNetwork?: AdsLibraryNetwork,
  region?: AdsLibraryRegion,
) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.adsLibraryNetworkChange, {
    network,
    previousNetwork,
    region,
  });
};

export const trackAdsLibraryRegionChange = (
  region: AdsLibraryRegion,
  network: AdsLibraryNetwork,
  previousRegion?: AdsLibraryRegion,
) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.adsLibraryRegionChange, {
    network,
    region,
    previousRegion,
  });
};

export const trackAdsLibraryFilterApply = (
  network: AdsLibraryNetwork,
  region: AdsLibraryRegion,
  filters: Record<string, unknown>,
) => {
  const context: AdsLibraryContext = {
    network,
    region,
  };

  Object.entries(filters).forEach(([key, value]) => {
    const serialized = serializeValue(value);
    if (serialized !== undefined) {
      context[key] = serialized;
    }
  });

  datadogActions.trackDatadogAction(DATADOG_EVENT.adsLibraryFilterApply, context);
};

export const trackAdsLibraryCreativeView = ({
  network,
  region,
  viewType,
  creativeId,
  adId,
  company,
  adCreativeType,
}: {
  network: AdsLibraryNetwork;
  region: AdsLibraryRegion;
  viewType: AdsLibraryCreativeViewType;
  creativeId: string | number;
  adId?: string;
  company?: string;
  adCreativeType?: string;
}) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.adsLibraryCreativeView, {
    network,
    region,
    viewType,
    creativeId: String(creativeId),
    adId,
    company,
    adCreativeType,
  });
};
